<!-- eslint-disable max-lines -->
<template>
    <!-- 列配置按钮左边那个批量上传弹框 -->
    <el-dialog
        v-dialogDrag
        class="receipt receiptSignBatchUpload"
        :closeOnClickModal="false"
        :visible="true"
        :before-close="beforeClose"
        width="50%"
    >
        <upload-new-btn
            v-loading="loading"
            ref="uploadButton"
            :multiple="true"
            businessKey="default"
            bucket="srm"
            contentType="application/octet-stream"
            :needBtn="false"
            :publicRead="1"
            :showFileLists="true"
            :on-preview="onPreview"
            :on-remove="onRemove"
            list-type="picture-card"
            @beforeUpload="beforeUpload"
            @callback="uploadResponse"
        >
            <div>
                <i class="el-icon-plus sign-for"></i>
                <span>上传回单</span>
            </div>
        </upload-new-btn>
        <div slot="title">
            <span>{{ batchUploadTitle }}</span
            >&nbsp;
            <span class="font"
                >(如果一个单号需要上传多张图片，图片命名请以单号-1，单号-2等结尾)</span
            >
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="beforeClose">取消</el-button>
            <el-button type="primary" @click="submit">提交</el-button>
        </div>
    </el-dialog>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import UploadNewBtn from '@/components/lots/OSS/UploadNewBtn';
import { receiptUpload } from '../../../api/receiptSign';
import { mapState } from 'vuex';
export default {
    components: {
        UploadNewBtn
    },
    props: {
        batchUploadShow: {
            type: Boolean,
            default () {
                return false;
            }
        },
        batchUploadTitle: {
            type: String,
            default () {
                return '';
            }
        },
        batchFlag: {
            type: String,
            default () {
                return '';
            }
        },
        selectData: {
            type: Array,
            default () {
                return [];
            }
        },
        searchObj: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            loading: false,
            fileArr: []
        };
    },
    methods: {
        onPreview (file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        onRemove (file, fileList) {
            this.fileArr = this.fileArr.filter(item => {
                return item.data.name !== file.name;
            });
        },
        beforeClose () {
            this.$confirm('您确定要取消上传吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$emit('update:batchUploadShow', false);
            }).catch(() => {
            });
        },
        beforeUpload ({ file }) {
            var extArr = ['jpg', 'jpeg', 'png', 'tif', 'bmp'];
            if (!extArr.includes(this.getFileExt(file.name))) {
                this.$message({
                    type: 'warning',
                    message: '文件格式只能为 JPG / JPEG / PNG / TIF / BMP',
                    duration: 5000,
                    showClose: true
                });
                this.$refs.uploadButton.handleUploadStatus(false);
                this.handleDeleteErrorFile(file);
                return false;
            }
            if (this.batchFlag === 'contractNo') { // 合同号
                if (!/^HT/.test(file.name)) {
                    this.$message.warning('文件名必须以 HT 开头');
                    this.$refs.uploadButton.handleUploadStatus(false);
                    this.handleDeleteErrorFile(file);
                    return false;
                }
            } else if (this.batchFlag === 'dispatchNo') { // 发车单号
                if (!/^CP/.test(file.name)) {
                    this.$message.warning('文件名必须以 CP 开头');
                    this.$refs.uploadButton.handleUploadStatus(false);
                    this.handleDeleteErrorFile(file);
                    return false;
                }
            }
            this.loading = true;
        },
        handleDeleteErrorFile (file) { // 清除不符合规格的文件
            this.$refs.uploadButton.$refs.ossElUpload.uploadFiles.forEach((e, i) => {
                if (file.name === e.name) {
                    this.$refs.uploadButton.$refs.ossElUpload.uploadFiles.splice(i, 1);
                }
            });
            this.$refs.uploadButton.uploadDataArr.forEach((e, i) => {
                if (file.name === e.file.name) {
                    this.$refs.uploadButton.uploadDataArr.splice(i, 1);
                }
            });
        },
        getFileExt (fileName) {
            return fileName && fileName.replace(/^.*\./, '').toLowerCase();
        },
        uploadResponse (response) {
            this.fileArr = response;
            this.loading = false;
        },
        submit () {
            if (!this.fileArr.length) {
                return this.$message.warning('请上传回单');
            }
            const params = {
                createUserName: this.user.userName,
                createUserCode: this.user.userCode,
                signFileUpload: 'N',
                receiptSource: '10'
            };
            params.fileUrls = this.fileArr.map(item => {
                return item.data.downUrl;
            });
            if (this.batchFlag === '') {
                params.taskNoList = this.selectData.map(item => {
                    return item.taskNo;
                });
            } else {
                params.batchFlag = this.batchFlag;
            }
            receiptUpload(params).then(res => {
                if (res) {
                    if (res.data && res.data.length > 0) {
                        let message = '';
                        res.data.forEach(item => {
                            message += `<div style='line-height: 30px;'>
                                        <span style='color: #909399;'>图片</span>
                                        <span style='color: #F56C6C;'>${item.pictureName}</span>
                                        <span style='color: #409EFF;'>${item.message}</span>
                                    <div>`;
                        });
                        const duration = 5000 + res.data.length * 1500;
                        this.$message({
                            type: 'warning',
                            duration,
                            dangerouslyUseHTMLString: true,
                            message,
                            showClose: true
                        });
                    } else {
                        this.$message.success('上传成功');
                        this.$emit('update:batchUploadShow', false);
                        this.$emit('refreshList', this.searchObj); // 更新首页列表数据
                    }
                }
            }).catch(() => {
                this.$message.error('上传失败');
            });
        }
    },
    computed: {
        ...mapState({ user: state => state.user })
    }
};
</script>

<style lang="less">
.receiptTile {
    .receipt {
        .form {
            .el-button--text {
                padding: 0 !important;
            }
        }

        .label {
            color: #999;
        }
        .el-upload--picture-card {
            line-height: 0 !important;
            height: 80px;
            width: 80px;
        }
        .uploads {
            height: 200px;
            overflow: auto;
        }
        .el-upload {
            text-align: center;
        }
        .font {
            font-weight: 400;
            font-size: 12px;
            color: #666666;
        }
    }
    .sign-for {
        display: block;
        margin: 16px 0 10px 0;
    }
}
</style>
